import React, { useEffect, useState } from 'react';
import Main from '../PortfolioComponents/Main'
import SecondComp from '../PortfolioComponents/SecondComp';
import { Testimonial } from '../HomeComponent/Testiomonial';
import Packages from '../HomeComponent/Packages';
import Faqs from '../HomeComponent/Faqs';

const Portfolio = () => {
    const [offsetY, setOffsetY] = useState(0);

  const handleScroll = () => {
    setOffsetY(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <>
    <div
        className="services-container"
        style={{
          backgroundPositionY: `${offsetY * 0.5}px`, // Adjust this multiplier to control the speed
        }}
      >
   <Main/>
   <SecondComp/>
   <Packages/>
   <Faqs/>
   <Testimonial/>
   </div>
    </>
  )
}

export default Portfolio
